import { Injectable, Inject } from "@angular/core";
import { DEVICE_LIST } from "@nms-ng2/app/shared/services/upgraded-provider/upgraded-providers";
import { NmsDialogService } from "@nms-angular-toolkit/nms-dialog";
import { ErrorResponseHandlerService } from "@nms-ng2/app/core/services/error-response-handler/error-response-handler.service";
import { LocationDeviceService } from "@nms-ng2/app/shared/services/devices/location-device.service";
import { IntermediateDevice } from "../intermediates-step.model";

/**
 * Serviço para gerenciar dispositivos intermediários no passo intermediates do circuito DWDM.
 */
@Injectable({
    providedIn: "root"
})
export class IntermediatesStepService {

    constructor(@Inject(DEVICE_LIST) private readonly deviceList: any,
                private readonly errorResponseHandlerService: ErrorResponseHandlerService,
                private readonly nmsDialogService: NmsDialogService,
                private readonly locationDeviceService: LocationDeviceService) {}

    /**
     * Carrega todas as localidades para mapear locationId para path
     */
    async loadLocations(): Promise<void> {
        try {
            await this.locationDeviceService.loadAndIndexLocations();
        } catch (error) {
            this.handleError(error);
        }
    }

    enrichDeviceWithLocation(device: IntermediateDevice): void {
        if (device.locationId) {
            device.location = this.locationDeviceService.getLocationLabel(device.locationId);
        } else {
            device.location = this.deviceList.DEFAULT_LOCATION;
        }
    }

    /**
     * Remove um device específico das listas de devices
     */
    removeDevice(devices: IntermediateDevice[], activeDevices: any[], intermediateDevice: IntermediateDevice): {
        devices: IntermediateDevice[], activeDevices: any[]} {
        const updatedDevices = devices.filter(device => device !== intermediateDevice);
        const updatedActiveDevices = activeDevices.filter(device => device.id !== intermediateDevice.resourceId);

        return {
            devices: updatedDevices,
            activeDevices: updatedActiveDevices
        };
    }

    /**
     * Remove todos os devices das listas
     */
    removeAllDevices(): { devices: IntermediateDevice[], activeDevices: any[] } {
        return {
            devices: [],
            activeDevices: []
        };
    }

    private handleError(error: any): void {
        const { description, details } = this.errorResponseHandlerService.buildErrorDescriptionDetails(error);
        this.nmsDialogService.openDialog(
            { description: description + details, acceptLabel: "OK", bindHtml: true },
            { maxWidth: "800px" }
        );
    }
}
